function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { isArray as z, isDate as Nt, isObject as yt, keys as C } from "./code-utils.js";
import { getByteLength as er } from "./string-utils.js";
import { logger as N } from "../../shared-lib/index.js";
import { toValidBackendTimeString as Ft } from "./date-utils.js";
import { BRAZE_ACTIONS as oo } from "./braze-actions.js";
import { SET_CUSTOM_USER_ATTRIBUTE_STRING as Dt } from "../common/constants.js";
export var CUSTOM_DATA_REGEX = /^[^\x00-\x1F\x22]+$/;
export var CUSTOM_ATTRIBUTE_SPECIAL_CHARS_REGEX = /[$.]/;
export var CUSTOM_ATTRIBUTE_RESERVED_OPERATORS = ["$add", "$update", "$remove", "$identifier_key", "$identifier_value", "$new_object", "$time", "$google_ad_personalization", "$google_ad_user_data"];
export var EMAIL_ADDRESS_REGEX = new RegExp(/^.+@.+\..+$/);
export var CUSTOM_PROPERTIES_MAX_SIZE_BYTES = 51200;
export var CUSTOM_PROPERTIES_MAX_SIZE_STRING = "50KB";
export var CUSTOM_ATTRIBUTES_MAX_SIZE_BYTES = 76800;
export var CUSTOM_ATTRIBUTES_MAX_SIZE_STRING = "75KB";
export var CUSTOM_ATTRIBUTE_MAX_DEPTH = 50;
export var BRAZE_ACTION_URI_REGEX = /^brazeActions:\/\/v\d+\//;
export var VALID_UTF8_STRING_NO_WHITESPACES_REGEX = /^[^\s]+$/;
export function validateCustomString(t, e, r) {
  var n = null != t && "string" == typeof t && ("" === t || null != t.match(CUSTOM_DATA_REGEX));
  return n || N.error("Cannot ".concat(e, " because ").concat(r, " \"").concat(t, "\" is invalid.")), n;
}
export function validateCustomAttributeKey(t) {
  return null != t && t.match(CUSTOM_ATTRIBUTE_SPECIAL_CHARS_REGEX) && -1 === CUSTOM_ATTRIBUTE_RESERVED_OPERATORS.indexOf(t) && N.warn("Custom attribute keys cannot contain '$' or '.'"), validateCustomString(t, "set custom user attribute", "the given key");
}
export function validatePropertyType(t) {
  var e = _typeof(t);

  return null == t || "number" === e || "boolean" === e || Nt(t) || "string" === e;
}
export function _validateNestedProperties(t, e, r) {
  var n = -1 !== r;
  if (n && r > 50) return N.error("Nested attributes cannot be more than 50 levels deep."), !1;
  var o = n ? r + 1 : -1;

  if (z(t) && z(e)) {
    for (var _r = 0; _r < t.length && _r < e.length; _r++) {
      if (Nt(t[_r]) && (e[_r] = Ft(t[_r])), !_validateNestedProperties(t[_r], e[_r], o)) return !1;
    }
  } else {
    if (!yt(t)) return validatePropertyType(t);

    var _iterator = _createForOfIteratorHelper(C(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r2 = _step.value;
        var i = t[_r2];
        if (n && !validateCustomAttributeKey(_r2)) return !1;

        if (Nt(i)) {
          e[_r2] = Ft(i);
        }

        if (!_validateNestedProperties(i, e[_r2], o)) return !1;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return !0;
}
export function _validateEventPropertyValue(t, e, r, n, o) {
  var i;
  return i = yt(t) || z(t) ? _validateNestedProperties(t, e, o ? 1 : -1) : validatePropertyType(t), i || N.error("Cannot ".concat(r, " because ").concat(n, " \"").concat(t, "\" is invalid.")), i;
}
export function validateStandardString(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var o = "string" == typeof t || null === t && n;
  return o || N.error("Cannot ".concat(e, " because ").concat(r, " \"").concat(t, "\" is invalid.")), o;
}
export function validateCustomProperties(t, e, r, n, o) {
  if (null == t && (t = {}), "object" != _typeof(t) || z(t)) return N.error("".concat(e, " requires that ").concat(r, " be an object. Ignoring ").concat(o, ".")), [!1, null];
  var i, a;
  e === Dt ? (i = 76800, a = "75KB") : (i = 51200, a = "50KB");
  var s = JSON.stringify(t);
  if (er(s) > i) return N.error("Could not ".concat(n, " because ").concat(r, " was greater than the max size of ").concat(a, ".")), [!1, null];
  var u;

  try {
    u = JSON.parse(s);
  } catch (t) {
    return N.error("Could not ".concat(n, " because ").concat(r, " did not contain valid JSON.")), [!1, null];
  }

  for (var _r3 in t) {
    if (e === Dt && !validateCustomAttributeKey(_r3)) return [!1, null];
    if (!validateCustomString(_r3, n, "the ".concat(o, " property name"))) return [!1, null];
    var _i = t[_r3];

    if (e !== Dt && null == _i) {
      delete t[_r3], delete u[_r3];
      continue;
    }

    Nt(_i) && (u[_r3] = Ft(_i));
    if (!_validateEventPropertyValue(_i, u[_r3], n, "the ".concat(o, " property \"").concat(_r3, "\""), e === Dt)) return [!1, null];
  }

  return [!0, u];
}
export function validateCustomAttributeArrayType(t, e) {
  var r = !1,
      n = !1;

  var o = function o() {
    N.error("Custom attribute arrays must be either string arrays or object arrays.");
  };

  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var i = _step2.value;

      if ("string" == typeof i) {
        if (n) return o(), [!1, !1];
        if (!validateCustomString(i, "set custom user attribute \"".concat(t, "\""), "the element in the given array")) return [!1, !1];
        r = !0;
      } else {
        if (!yt(i)) return o(), [!1, !1];
        if (r) return o(), [!1, !1];
        if (!validateCustomProperties(i, Dt, "attribute value", "set custom user attribute \"".concat(t, "\""), "custom user attribute")) return [!1, !1];
        n = !0;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return [r, n];
}
export function isValidEmail(t) {
  return "string" == typeof t && null != t.toLowerCase().match(EMAIL_ADDRESS_REGEX);
}
export function isValidBrazeActionJson(t) {
  if (!(oo.properties.type in t)) return !1;

  switch (t[oo.properties.type]) {
    case oo.types.io:
      if (oo.properties.eo in t) return !0;
      break;

    case oo.types.logCustomEvent:
    case oo.types.setEmailNotificationSubscriptionType:
    case oo.types.setPushNotificationSubscriptionType:
    case oo.types.setCustomUserAttribute:
    case oo.types.addToSubscriptionGroup:
    case oo.types.removeFromSubscriptionGroup:
    case oo.types.addToCustomAttributeArray:
    case oo.types.removeFromCustomAttributeArray:
    case oo.types.co:
    case oo.types.mo:
      if (oo.properties.so in t) return !0;
      break;

    case oo.types.requestPushPermission:
      return !0;

    default:
      return !1;
  }

  return !1;
}
export function isValidBrazeActionType(t) {
  var e = !1;
  return Object.keys(oo.types).forEach(function (r) {
    oo.types[r] !== t.toString() || (e = !0);
  }), e;
}
export function isValidBannerPlacementId(t) {
  return VALID_UTF8_STRING_NO_WHITESPACES_REGEX.test(t);
}